import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import noImgCoffee from "../../../assets/images/noImg.jpg";
import Loading from '../../ui/Loading';
import { IMAGE_BASE_URL } from '../../../utils/env';
import LoadingImg from '../../ui/LoadingImg';
import { useMutationData } from '../../../hooks/api/useMutationData';
import { selectCategories, selectQuantity, selectSize } from '../../../features/guest/guestSlice';
import AvailableProductModalHeader from '../../common/headers/AvailableProductModalHeader';
import useGuestAction from '../../../hooks/actions/useGuestAction';
import ProductModalAddons from './ProductModalAddons';
import { useAvailableProductCartUseMemo } from '../../../hooks/use-memo/useAvailableProductCartUseMemo';

export default function ProductModal() {

    const addQty = useSelector(selectQuantity)
    const { isLoadingAddProductToCart, isLoadingUpdateCartProduct } = useMutationData()
    const [isLoadingImg, setIsLoadingImg] = useState(true);
    const { handleQuantityChange, handleAddToCart, handleCloseModal, isUpdate } = useGuestAction();
    const selectedCategories = useSelector(selectCategories);
    const selectedSize = useSelector(selectSize);
    const { selectedProduct } = useAvailableProductCartUseMemo({selectedCategories, selectedSize});
    const isLoading = isLoadingUpdateCartProduct || isLoadingAddProductToCart;

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = '' };
    }, []);

    const imgSrc = selectedProduct?.image ? `${IMAGE_BASE_URL}/${selectedProduct.image}` : noImgCoffee
    const productName = selectedProduct?.productName ?? ''
    const addons = selectedProduct?.addons

    return (
        <div className='fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-101'>
            <div className="relative w-[80%] min-w-[320px] max-w-[450px] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[40%] lg:w-[25%]">
                <div className='flex flex-col w-full'>
                    <div className='py-5'>
                        <AvailableProductModalHeader productName={productName} onClose={handleCloseModal}/>
                        <hr className="h-px bg-gray-200 border-0" />
                        <div className='w-full space-y-2 mt-2'>
                            <div className="relative mx-auto w-40 h-40">
                                {isLoadingImg && (
                                    <div className="absolute inset-0 flex items-center justify-center bg-gray-50 rounded-xl">
                                        <LoadingImg />
                                    </div>
                                )}
                                <img
                                    src={imgSrc}
                                    alt={selectedProduct?.productName ?? "Product"}
                                    className={`w-full h-full rounded-xl object-cover transition-opacity duration-300 ${
                                        isLoadingImg ? "opacity-0" : "opacity-100"
                                    }`}
                                    onLoad={() => setIsLoadingImg(false)}
                                    onError={(e) => {
                                        setIsLoadingImg(false);
                                        e.currentTarget.src = noImgCoffee;
                                    }}
                                />
                            </div>
                            <div className='space-y-0'>
                                <p className="text-sm font-semibold text-gray-800 leading-tight">{selectedProduct?.productName}</p>
                                <p className='text-xs text-cbColor'>{selectedProduct?.categoryName}</p>
                            </div>
                        </div>
                        <div className='w-full flex flex-col space-y-2'>
                            <div className='w-full flex'>
                                <div className='w-full pt-1'>
                                    <div className="flex flex-wrap gap-2">
                                        <button className={`border py-0.5 px-1 text-xs rounded cursor-pointer select-none transition-all border-cbColor bg-orange-100 font-medium`}>
                                            {selectedProduct?.size}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {addons?.length !== 0 && (<ProductModalAddons addons={addons}/>)}
                            <hr className="h-px bg-gray-200 border-0" />
                            <div className='w-full flex justify-between space-x-2'>
                                <div className="w-1/2 flex justify-between items-center gap-2 border border-cbColor bg-gray-100 rounded p-1">
                                    <button 
                                        onClick={() => handleQuantityChange("decrement")}
                                        className="w-10 h-6 flex items-center justify-center text-cbColor rounded transition-all"
                                        disabled={isLoading}
                                    >
                                        -
                                    </button>
                                    <span className="text-center text-xs font-bold text-gray-900">
                                        {addQty}
                                    </span>
                                    <button 
                                        onClick={() => handleQuantityChange("increment")}
                                        className="w-10 h-6 flex items-center justify-center text-cbColor rounded transition-all"
                                        disabled={isLoading}
                                    >
                                        +
                                    </button>
                                </div>
                                <button
                                    disabled={isLoading}
                                    onClick={handleAddToCart}
                                    className={`w-1/2 ${isLoading ? 'bg-gray-300' : 'bg-cbColor'} text-white text-xs px-1 py-2 rounded transition`}
                                >
                                    {isLoading ? (
                                            <Loading setH={'h-[20px]'}/>
                                        ) : (
                                            `${isUpdate ? 'Update' : 'Add to Cart'}`
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
